import React from 'react';

export default function Modal({ children, onClose }) {
  return (
    <div id="modalSeriesDetails" className="modal modalSeriesDetails show" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <button type="button" className="close modal-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
            <span aria-hidden="true">x</span>
          </button>
          <div className="modal-body config-validation">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}